import React from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import { liveClassTabsData } from "../../../data/SidebarData";
import Tabs from "../../../Components/Common/Tabs";
import StaticPageForm from "../../../Components/Common/Forms/StaticPageForm";
import { liveClassSubsUrls } from "../../../Api/Auth/ApiUrls";
import useSWR from "swr";

const LiveClassIndex = () => {
  const { data } = useSWR(liveClassSubsUrls.list(""));

  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={liveClassTabsData} />
      <StaticPageForm
        title="Live Class"
        category="civil"
        typeData={data}
        type="liveClassSubscription"
        promo
        multipleImage
        // filter="subscription"
        // subscription
      />
    </div>
  );
};

export default LiveClassIndex;
